import type * as React from 'react'

import {stringifyId} from '../../../../types'
import type {BuildTypeId, ProjectId} from '../../../../types'
import {resolveRelative} from '../../../../utils/url'

export const getHolderTemplateLink = (id: BuildTypeId | null | undefined): string =>
  id != null
    ? resolveRelative(`/admin/editBuild.html`, {
        id: `template:${stringifyId(id)}`,
      })
    : ''
export const getHolderProjectLink = (id: ProjectId | null | undefined): string =>
  id != null
    ? resolveRelative(`/project.html`, {
        projectId: stringifyId(id),
      })
    : ''
export const getHolderBuildTypeLink = (id: BuildTypeId | null | undefined): string =>
  id != null
    ? resolveRelative(`/viewType.html`, {
        buildTypeId: stringifyId(id),
      })
    : ''
export const onMoveOutside = (event: React.SyntheticEvent<any>): void => event.stopPropagation()
